export const SERVER_NON_FIELD_ERROR = 'serverError'

export const QA_NAME_FORM_MODAL = 'form'

export const CONFIRMATION_QA_NAME_FORM_MODAL = 'confirmation'

export const ERROR_NOTIFICATION_COUNT = 1

export const FORM_FIELD_NAME_NO_CHANGED = 'no_changed'

export const FORM_FIELD_NAME_FILES_UPLOADING = 'files_uploading'

export const FORM_FIELD_NAME_FILES_WITH_ERRORS = 'files_with_errors'

export const RESPONSIBLE_MANAGERS_LIMIT = 140

export const FORM_NOTIFICATION_NAME_RESPONSIBLE_MANAGERS_LIMIT =
  'max_responsible_managers_info'

export const FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED =
  'max_responsible_managers_error'
